import * as React from "react";
import {
    PlasmicDocumentEntry,
    DefaultDocumentEntryProps
} from "./plasmic/main/PlasmicDocumentEntry";

export interface DocumentEntryProps extends DefaultDocumentEntryProps {
    document: any,
    showGoogleDriveSheet: any,
    removeFile: any
}

function DocumentEntry({document, showGoogleDriveSheet, removeFile, ...rest}: DocumentEntryProps) {
    return <PlasmicDocumentEntry
        {...rest}
        file={{
            onClick: () => window.open(document.url, '_blank')
        }}
        deleteFile={{
            onClick: () => removeFile(document)
        }}
    >
        {document.name}
    </PlasmicDocumentEntry>;
}

export default DocumentEntry;
